import React from "react";

const FieldError = ({ id, error, touched }) =>
  touched && error ? (
    <div id={id} className="error-message" role="alert">
      {error}
    </div>
  ) : null;

export default FieldError;
